import { useCallback, useState } from 'react';

const useDeleteGuestDestinations = () => {
  const [deleteGuestDestinations, setDeleteGuestDestinations] = useState<string[]>([]);

  const handelDeleteGuestDestination = useCallback((id: string) => {
    setDeleteGuestDestinations(prev => [...prev, id]);
  }, []);

  return [deleteGuestDestinations, handelDeleteGuestDestination] as const;
};

export default useDeleteGuestDestinations;
